<template>
  <div class="flex items-center gap-8">
    <RevLink
      class="body-2-link"
      target="_blank"
      :to="props.labelReturn.shipmentLabelUrl"
    >
      {{ i18n(translations.labelReturn) }}
    </RevLink>

    <RevLink
      v-if="props.labelReturn.qrCodeUrl"
      class="body-2-link"
      target="_blank"
      :to="props.labelReturn.qrCodeUrl"
    >
      {{ i18n(translations.qrCodeLabel) }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import type { LabelReturn } from '~/api/seller-after-sales/types'

import translations from './LabelReturn.translations'

const i18n = useI18n()

const props = defineProps<{ labelReturn: LabelReturn }>()
</script>
